<template>
  <div>
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <div class="child is-box box">
              <h1 class="title">Game Editor </h1>
              <h3 class="subtitle">{{Fixture.match_date}} {{Fixture.home_team}} VS {{Fixture.away_team}}</h3>
            <tabs type="boxed" :is-fullwidth="true" alignment="centered" size="medium">
              <tab-pane label="Fixture Data">
                <article class="is-child box">
                  <h1 class="title">  Fixture Data </h1>
                  <form v-on:submit="">
                    <div class="block">
                      <div class="control is-horizontal">
                        <div class="control-label">
                          <label class="label">Home Team</label>
                        </div>
                        <div class="control is-grouped">
                          <p class="control is-expanded">
                            <input class="input" type="text" placeholder="" v-model="this.Fixture.home_team">
                          </p>
                        </div>
                      </div>
                      <div class="control is-horizontal">
                        <div class="control-label">
                          <label class="label">Away Team</label>
                        </div>
                        <div class="control is-grouped">
                          <p class="control is-expanded">
                            <input class="input" type="text" placeholder="" v-model="this.Fixture.away_team">
                          </p>
                        </div>
                      </div>
                      <div class="control is-horizontal">
                        <div class="control-label">
                        <label class="label">Date</label>
                        </div> 
                        <p class="control">
                          <datepicker placeholder="Pick Date / Time" :config="{ enableTime: true, enableSeconds: true, noCalendar: false, time_24hr:true }" v-model="this.Fixture.match_date"></datepicker>
                        </p>
                      </div>            
                      <div class="control is-horizontal">
                        <div class="control-label">
                          <label class="label">Location</label>
                        </div>
                        <div class="control is-grouped">
                          <p class="control is-expanded">
                            <input class="input" type="text" placeholder="IAW" >
                          </p>
                        </div>
                      </div>
                      <div class="control is-horizontal">
                        <div class="control-label">
                          <label class="label">Attendence</label>
                        </div>
                        <div class="control is-grouped">
                          <p class="control is-expanded">
                            <input class="input" type="number" placeholder="2300" >
                          </p>
                        </div>
                      </div>
                      <div class="control is-horizontal">
                        <div class="control-label">
                          <label class="label">Competition</label>
                        </div>
                        <div class="control is-grouped">
                          <p class="control is-expanded">
                          <input class="input " type="text" placeholder="EIHL" v-model="this.Fixture.leauge" >
                          </p>
                        </div>
                      </div>
                      <div class="control is-horizontal">
                        <div class="control-label">
                          <label class="label"></label>
                        </div>
                        <div class="control">
                          <button name="submit" class="button is-primary is-medium">Submit</button>
                          <router-link class="button is-link is-small" v-bind:to="'/editors/hits/:gameId'">Cancel</router-link>
                        </div>
                      </div>
                    </div>
                  </form>
                </article>
              </tab-pane>
              <tab-pane label="Goals">
                  <article class="is-child box">
                    <a class="button is-success is-active is-medium" style="margin:0 auto" :href="'/goal/add'">New Goal</a>
                    <table class="table">
                      <thead>
                          <th>Goal Id</th>
                          <th>Goal for Team</th>
                          <th>Goal Scorer</th>
                          <th>First Assist</th>
                          <th>Second Assist</th>
                          <th>Period</th>
                          <th>Game Time</th>
                          <th>Situation</th>
                          <th>Actions</th>
                          <th></th>
                          <th></th>
                      </thead>
                      <tbody>
                        <tr v-for="goal in Goals">
                          <td>{{goal.id}}</td> 
                          <td> 
                            <p class="control">
                              <span   class="select">
                                <select v-model="goal.for_team.name">
                                  <option v-for="teamOption in teamOptions" v-bind:value="teamOption.value">
                                    {{ teamOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p>
                          </td>                           
                          <td><strong><input class="input" type="text" v-model="goal.scorer.player_number"></strong></td> 
                          <td><input class="input" type="text" v-model="goal.first_assist.player_number"></td> 
                          <td><input class="input" type="text" v-model="goal.second_assist.player_number"></td> 
                          <td>
                            <p class="control">
                              <span class="select">
                                <select v-model="goal.period">
                                  <option v-for="periodOption in periodOptions" v-bind:value="periodOption.value">
                                    {{ periodOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p>
                          </td> 
                          <td><datepicker  placeholder="--:--" :config="{ enableTime: true, enableSeconds: true, noCalendar: true, time_24hr:true }" value="00:00:00" v-model="goal.game_time"></datepicker></td> 
                          <td>
                            <p class="control">
                              <span class="select">
                                <select v-model="goal.situation.secondary_situation">
                                  <option v-for="situationOption in situationOptions" v-bind:value="situationOption.value">
                                    {{ situationOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p>
                          </td>
                          <td><a class="button is-primary is-active is-small" v-on:click="updateGoalRow(goal)">Update</a></td>
                          <td><router-link class="button is-success is-active is-small" v-bind:to="'/goal-edit/' + goal.id ">Verify</router-link></td>
                          <td><a class="button is-danger is-active is-small" v-on:click="deleteGoal(goal.id)">Delete</a></td>
                        </tr>
                      </tbody>
                    </table>
                  </article>
              </tab-pane>
                <tab-pane label="Shots">
                  <article class="is-child box">
                    <a class="button is-success is-active is-medium" style="margin:0 auto" :href="'/shots/add'">New Shot</a>
                    <table class="table">
                      <thead>
                          <th>Shots Id</th>
                          <th>Team</th>
                          <th>Player</th>
                          <th>Shot Result</th>
                          <th>Shot Location</th>
                          <th>Period</th>
                          <th>Game Time</th>
                          <th>Situation</th>
                          <th>Actions</th>
                          <th></th>
                          <th></th>
                      </thead>
                      <tbody>
                        <tr v-for="shot in Shots">
                          <td>{{shot.id}}</td> 
                          <td> 
                            <p class="control">
                              <span   class="select">
                                <select v-model="shot.for_team.name">
                                  <option v-for="teamOption in teamOptions" v-bind:value="teamOption.value">
                                    {{ teamOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p>
                          </td> 
                          <td><strong><input class="input" type="text" v-model="shot.home_player"></strong></td> 
                          <td>
                            <p class="control">
                              <span class="select">
                                <select v-model="shot.result">
                                  <option v-for="resultOption in shotResultOptions" v-bind:value="resultOption.value">
                                    {{ resultOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p>
                          </td>
                          <td><input class="input" type="text" v-model="shot.location"></td> 
                          <td>
                            <p class="control">
                              <span class="select">
                                <select v-model="shot.period">
                                  <option v-for="periodOption in periodOptions" v-bind:value="periodOption.value">
                                    {{ periodOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p>
                          </td>
                          <td><datepicker  placeholder="--:--" :config="{ enableTime: true, enableSeconds: true, noCalendar: true, time_24hr:true }" value="00:00:00" v-model="shot.game_time"></datepicker></td> 
                          <td>
                            <p class="control">
                              <span class="select">
                                <select v-model="shot.situation.secondary_situation">
                                  <option v-for="situationOption in situationOptions" v-bind:value="situationOption.value">
                                    {{ situationOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p>
                          </td>
                          <td><a class="button is-primary is-active is-small" v-on:click="updateShotRow(shot)">Update</a></td>
                          <td><router-link class="button is-success is-active is-small" v-bind:to="'/shot-edit/' + shot.id ">Verify</router-link></td>
                          <td><a class="button is-danger is-active is-small" v-on:click="deleteShot(shot.id)">Delete</a></td>
                        </tr>
                      </tbody>
                    </table>
                  </article>
                </tab-pane>
                <tab-pane label="Faceoffs">
                  <article class="is-child box">
                    <a class="button is-success is-active is-medium" style="margin:0 auto" :href="'/shots/add'">New Faceoff</a>
                    <table class="table">
                      <thead>
                          <th>Faceoff Id</th>
                          <th>Home Player</th>
                          <th>Away Player</th>
                          <th>Result</th>
                          <th>Zone</th>
                          <th>Lane</th>
                          <th>Period</th>
                          <th>Game Time</th>
                          <th>Situation</th>
                          <th>Actions</th>
                          <th></th>
                          <th></th>
                      </thead>
                      <tbody>
                        <tr v-for="faceoff in Faceoffs">
                          <td>{{faceoff.id}}</td> 
                          <td><strong><input class="input" type="text" v-model="faceoff.home_player"></strong></td> 
                          <td><strong><input class="input" type="text" v-model="faceoff.away_player"></strong></td> 
                          <td>
                            <p class="control">
                              <span class="select">
                                <select v-model="faceoff.result">
                                  <option v-for="resultOption in faceoffResultOptions" v-bind:value="resultOption.value">
                                    {{ resultOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p></td> 
                          <td ><input class="input" type="text" v-model="faceoff.zone"></td> 
                          <td><input class="input" type="text" v-model="faceoff.lane"></td> 
                          <td>
                            <p class="control">
                              <span class="select">
                                <select v-model="faceoff.period">
                                  <option v-for="periodOption in periodOptions" v-bind:value="periodOption.value">
                                    {{ periodOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p>
                          </td> 
                          <td><datepicker  placeholder="--:--" :config="{ enableTime: true, enableSeconds: true, noCalendar: true, time_24hr:true }" value="00:00:00" v-model="faceoff.game_time"></datepicker></td> 
                          <td>
                            <p class="control">
                              <span class="select">
                                <select v-model="faceoff.situation.secondary_situation">
                                  <option v-for="situationOption in situationOptions" v-bind:value="situationOption.value">
                                    {{ situationOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p>
                          </td>
                          <td><a class="button is-primary is-active is-small" v-on:click="updateFaceoff(faceoff)">Update</a></td>
                          <td><router-link class="button is-success is-active is-small" v-bind:to="'/faceoff-edit/' + faceoff.id ">Verify</router-link></td>
                          <td><a class="button is-danger is-active is-small" v-on:click="deleteFaceoff(faceoff.id)">Delete</a></td>
                        </tr>
                      </tbody>
                    </table>
                  </article>
                </tab-pane>
                <tab-pane label="Turnovers">
                  <article class="is-child box">
                    <a class="button is-success is-active is-medium" style="margin:0 auto" :href="'/shots/add'">New Turnover</a>
                    <table class="table">
                      <thead>
                          <th>Turnover Id</th>
                          <th>Player</th>
                          <th>Result</th>
                          <th>Period</th>
                          <th>Game Time</th>
                          <th>Situation</th>
                          <th>Actions</th>
                          <th></th>
                          <th></th>
                      </thead>
                      <tbody>
                        <tr v-for="turnover in Turnovers">
                          <td>{{turnover.id}}</td> 
                          <td><strong><input class="input" type="text" v-model="turnover.home_player"></strong></td> 
                          <td>
                            <p class="control">
                              <span class="select">
                                <select v-model="turnover.type">
                                  <option v-for="resultOption in turnoverResultOptions" v-bind:value="resultOption.value">
                                    {{ resultOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p></td>
                            <td> 
                            <p class="control">
                              <span class="select">
                                <select v-model="turnover.period">
                                  <option v-for="periodOption in periodOptions" v-bind:value="periodOption.value">
                                    {{ periodOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p>
                          </td> 
                          <td><datepicker  placeholder="--:--" :config="{ enableTime: true, enableSeconds: true, noCalendar: true, time_24hr:true }" value="00:00:00" v-model="turnover.game_time"></datepicker></td> 
                          <td>
                            <p class="control">
                              <span class="select">
                                <select v-model="turnover.situation.secondary_situation">
                                  <option v-for="situationOption in situationOptions" v-bind:value="situationOption.value">
                                    {{ situationOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p>
                          </td>
                          <td><a class="button is-primary is-active is-small" v-on:click="updateTurnover(turnover)">Update</a></td>
                          <td><router-link class="button is-success is-active is-small" v-bind:to="'/turnover-edit/' + turnover.id ">Verify</router-link></td>
                          <td><a class="button is-danger is-active is-small" v-on:click="deleteTurnover(turnover.id)">Delete</a></td>
                        </tr>
                      </tbody>
                    </table>
                  </article>
                </tab-pane>
                <tab-pane label="Hits">
                  <article class="is-child box">
                    <a class="button is-success is-active is-medium" style="margin:0 auto" :href="'/shots/add'">New Hit</a>
                    <table class="table">
                      <thead>
                          <th>Hit Id</th>
                          <th>Home Player</th>
                          <th>Away Player</th>
                          <th>Period</th>
                          <th>Game Time</th>
                          <th>Situation</th>
                          <th>Actions</th>
                          <th></th>
                          <th></th>
                      </thead>
                      <tbody>
                        <tr v-for="hit in Hits">
                          <td>{{hit.id}}</td> 
                          <td><strong><input class="input" type="text" v-model="hit.home_player"></strong></td> 
                          <td><strong><input class="input" type="text" v-model="hit.away_player"></strong></td>
                            <td> 
                            <p class="control">
                              <span class="select">
                                <select v-model="hit.period">
                                  <option v-for="periodOption in periodOptions" v-bind:value="periodOption.value">
                                    {{ periodOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p>
                          </td> 
                          <td><datepicker  placeholder="--:--" :config="{ enableTime: true, enableSeconds: true, noCalendar: true, time_24hr:true }" value="00:00:00" v-model="hit.game_time"></datepicker></td> 
                          <td>
                            <p class="control">
                              <span class="select">
                                <select v-model="hit.situation.secondary_situation">
                                  <option v-for="situationOption in situationOptions" v-bind:value="situationOption.value">
                                    {{ situationOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p>
                          </td>
                          <td><a class="button is-primary is-active is-small" v-on:click="updateHit(hit)">Update</a></td>
                          <td><router-link class="button is-success is-active is-small" v-bind:to="'/hit-edit/' + hit.id ">Verify</router-link></td>
                          <td><a class="button is-danger is-active is-small" v-on:click="deleteHit(hit.id)">Delete</a></td>
                        </tr>
                      </tbody>
                    </table>
                  </article>
                </tab-pane>
                <tab-pane label="PIMS">
                  <article class="is-child box">
                    <a class="button is-success is-active is-medium" style="margin:0 auto" :href="'/shots/add'">New Penalty</a>
                    <table class="table">
                      <thead>
                          <th>PIM Id</th>
                          <th>Taker</th>
                          <th>Drawer</th>
                          <th>Type</th>
                          <th>For</th>
                          <th>Time</th>
                          <th>Period</th>
                          <th>Game Time</th>
                          <th>Actions</th>
                          <th></th>
                          <th></th>
                      </thead>
                      <tbody>
                        <tr v-for="pims in Pims">
                          <td>{{pims.id}}</td> 
                          <td><strong><input class="input" type="text" v-model="pims.taker"></strong></td> 
                          <td><strong><input class="input" type="text" v-model="pims.drawer"></strong></td> 
                          <td>
                            <p class="control">
                              <span class="select">
                                <select v-model="pims.type">
                                  <option v-for="resultOption in pimTypeOptions" v-bind:value="resultOption.value">
                                    {{ resultOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p></td> 
                          <td>
                            <p class="control">
                              <span class="select">
                                <select v-model="pims.for">
                                  <option v-for="pimOption in pimForOptions" v-bind:value="pimOption.value">
                                    {{ pimOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p></td> 
                          <td ><input class="input" type="number" v-model="pims.time"></td> 
                          <td>
                            <p class="control">
                              <span class="select">
                                <select v-model="pims.period">
                                  <option v-for="periodOption in periodOptions" v-bind:value="periodOption.value">
                                    {{ periodOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p>
                          </td> 
                          <td><datepicker  placeholder="--:--" :config="{ enableTime: true, enableSeconds: true, noCalendar: true, time_24hr:true }" value="00:00:00" v-model="pims.game_time"></datepicker></td> 
                          <td><a class="button is-primary is-active is-small" v-on:click="updatePIM(pims)">Update</a></td>
                          <td><router-link class="button is-success is-active is-small" v-bind:to="'/pims-edit/' + pims.id ">Verify</router-link></td>
                          <td><a class="button is-danger is-active is-small" v-on:click="deletePIM(pims.id)">Delete</a></td>
                        </tr>
                        <tr>
                          <td><strong style="color:green;">New PIM</strong></td> 
                          <td><strong><input class="input" type="text" v-model="this.NewPim.taker"></strong></td> 
                          <td><strong><input class="input" type="text" v-model="this.NewPim.drawer"></strong></td> 
                          <td>
                            <p class="control">
                              <span class="select">
                                <select v-model="this.NewPim.type">
                                  <option v-for="resultOption in pimTypeOptions" v-bind:value="resultOption.value">
                                    {{ resultOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p></td> 
                          <td>
                            <p class="control">
                              <span class="select">
                                <select v-model="this.NewPim.for">
                                  <option v-for="pimOption in pimForOptions" v-bind:value="pimOption.value">
                                    {{ pimOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p></td> 
                          <td ><input class="input" type="number" v-model="NewPim.time"></td> 
                          <td>
                            <p class="control">
                              <span class="select">
                                <select v-model="NewPim.period">
                                  <option v-for="periodOption in periodOptions" v-bind:value="periodOption.value">
                                    {{ periodOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p>
                          </td> 
                          <td><datepicker  placeholder="--:--" :config="{ enableTime: true, enableSeconds: true, noCalendar: true, time_24hr:true }" value="00:00:00" v-model="NewPim.game_time"></datepicker></td> 
                          <td><a class="button is-primary is-active is-small" v-on:click="addPIM(NewPim)">Add</a></td>
                        </tr>
                      </tbody>
                    </table>
                  </article>
                </tab-pane>
                <tab-pane label="Time On Ice">
                  <article class="is-child box">
                    <table class="table">
                      <thead>
                        <th>#</th>
                        <th>Player</th>
                        <th>GP</th>
                        <th>+ Shots</th>
                        <th>- Shots</th>
                        <th>Shifts</th>
                        <th>Time Avg Shift</th>
                        <th>Time Total</th>
                        <th>Time 5v5</th>
                        <th>Time 4v4</th>
                        <th>Time PP</th>
                        <th>Time SH</th>
                        <th>Actions</th>
                          <th></th>
                          <th></th>
                      </thead>
                      <tbody>
                        <tr v-for="toi in TOI">
                          <td>{{toi.player_number}}</td>
                          <td>{{toi.player_forename}} {{toi.player_surname}}</td>
                          <td><label ><input class="checkbox" type="checkbox"  checked="checked" value="" v-model="toi.played_in_game"></label></td> 
                          <td><input class="input " type="number" placeholder="0" v-model="toi.shots_for"></td>
                          <td><input class="input " type="number" placeholder="0" v-model="toi.shots_against"></td>
                          <td><input class="input " type="number" placeholder="0" v-model="toi.shifts"></td>
                          <td><datepicker  placeholder="--:--" :config="{ enableTime: true, enableSeconds: true, noCalendar: true, time_24hr:true }" value="00:00:00" v-model="toi.avg_shift"></datepicker></td>
                          <td><datepicker  placeholder="--:--" :config="{ enableTime: true, enableSeconds: true, noCalendar: true, time_24hr:true }" value="00:00:00" v-model="toi.total_time"></datepicker></td>
                          <td><datepicker  placeholder="--:--" :config="{ enableTime: true, enableSeconds: true, noCalendar: true, time_24hr:true }" value="00:00:00" v-model="toi.time_5v5"></datepicker></td>
                          <td><datepicker  placeholder="--:--" :config="{ enableTime: true, enableSeconds: true, noCalendar: true, time_24hr:true }" value="00:00:00" v-model="toi.time_4v4"></datepicker></td>
                          <td><datepicker  placeholder="--:--" :config="{ enableTime: true, enableSeconds: true, noCalendar: true, time_24hr:true }" value="00:00:00" v-model="toi.time_PP"></datepicker></td>
                          <td><datepicker  placeholder="--:--" :config="{ enableTime: true, enableSeconds: true, noCalendar: true, time_24hr:true }" value="00:00:00" v-model="toi.time_SH"></datepicker></td>
                          <td><a class="button is-primary is-active is-small" v-on:click="updateToi(toi)">Update</a></td>
                          <td><router-link class="button is-success is-active is-small" v-bind:to="'/pims-edit/' + toi.id ">Verify</router-link></td>
                          <td><a class="button is-danger is-active is-small" v-on:click="deleteToi(toi.id)">Clear</a></td>
                        </tr>
                      </tbody>
                    </table>
                    <form>
                      <p class="control" style="margin-top:20px">
                        <button name="submit" class="button is-primary is-medium">Upload All</button>
                      </p>
                    </form>
                  </article>
                </tab-pane>
                <tab-pane label="+/-">
                  <article class="is-child box">
                    <table class="table">
                      <thead>
                          <th>Goal Id</th>
                          <th>Goal for Team</th>
                          <th>Goal Scorer</th>
                          <th>Period</th>
                          <th>Game Time</th>
                          <th>Situation</th>
                          <th>Player 1</th>
                          <th>Player 2</th>
                          <th>Player 3</th>
                          <th>Player 4</th>
                          <th>Player 5</th>
                          <th>Actions</th>
                          <th></th>
                          <th></th>
                      </thead>
                      <tbody>
                        <tr v-for="plusMinus in Goals">
                          <td>{{plusMinus.id}}</td> 
                          <td> 
                            <p class="control">
                              <span   class="select">
                                <select v-model="plusMinus.for_team.name">
                                  <option v-for="teamOption in teamOptions" v-bind:value="teamOption.value">
                                    {{ teamOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p>
                          </td>
                          <td><strong><input class="input" type="text" v-model="plusMinus.scorer.player_number"></strong></td>
                          <td>
                            <p class="control">
                              <span class="select">
                                <select v-model="plusMinus.period">
                                  <option v-for="periodOption in periodOptions" v-bind:value="periodOption.value">
                                    {{ periodOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p>
                          </td>
                          <td><datepicker  placeholder="--:--" :config="{ enableTime: true, enableSeconds: true, noCalendar: true, time_24hr:true }" value="00:00:00" v-model="plusMinus.game_time"></datepicker></td> 
                          <td>
                            <p class="control">
                              <span class="select">
                                <select v-model="plusMinus.situation.secondary_situation">
                                  <option v-for="situationOption in situationOptions" v-bind:value="situationOption.value">
                                    {{ situationOption.text }}
                                  </option>
                                </select>
                              </span>
                            </p>
                          </td>
                          <td><input class="input" type="text" v-model="plusMinus.first_assist.player_number"></td>
                          <td><input class="input" type="text" v-model="plusMinus.second_assist.player_number"></td>
                          <td><input class="input" type="text" v-model="plusMinus.second_assist.player_number"></td>
                          <td><input class="input" type="text" v-model="plusMinus.second_assist.player_number"></td>
                          <td><input class="input" type="text" v-model="plusMinus.second_assist.player_number"></td>
                          <td><a class="button is-primary is-active is-small" v-on:click="updatePlusMinus(plusMinus)">Update</a></td>
                          <td><router-link class="button is-success is-active is-small" v-bind:to="'/plusMinus-edit/' + plusMinus.id ">Verify</router-link></td>
                          <td><a class="button is-danger is-active is-small" >Clear</a></td>
                        </tr>
                      </tbody>
                    </table>
                  </article>
                </tab-pane>
            </tabs>
          </div>
        </article> 
    </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/mixins';
.small {
  font-size: 1em;
  display: inline-block;
}
.button {
  margin: 5px 0 0;
}

.control .button {
  margin: inherit;
}
.select select{
  font-size: 0.8em;
}
.select{
   height:1.5em;
   font-size:16px;
}
.control.has-addons {
  @include mobile() {
    input {
      width: 100%;
    }

    input.is-expanded {
      flex-shrink: 1;
    }
  }
}
</style>

<script>
import { Tabs, TabPane } from 'vue-bulma-tabs'
import Cleave from 'vue-cleave'
import 'cleave.js/dist/addons/cleave-phone.cn'
import Datepicker from 'vue-bulma-datepicker'
import Vue from 'vue'
import Notification from 'vue-bulma-notification'

const NotificationComponent = Vue.extend(Notification)

const openNotification = (propsData = {
  title: '',
  message: '',
  type: '',
  direction: '',
  duration: 4500,
  container: '.notifications'
}) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData
  })
}
export default {
  name: 'f',
  components: {
    Tabs,
    TabPane,
    Cleave,
    Datepicker,
    Notification
  },
  data () {
    return {
      Fixture: [],
      Goals: [],
      Shots: [],
      Faceoffs: [],
      Turnovers: [],
      Hits: [],
      Pims: [],
      NewPim: [{
        id: 0,
        taker: 0,
        drawer: 0,
        type: '',
        for: '',
        time: '',
        period: '',
        game_time: ''
      }],
      PlusMinus: [],
      TOI: [],
      gameId: 0,
      tabSelected: 'FixtureInfo',
      teamSelect: [],
      teamOptions: [],
      periodOptions: [
        {text: 1, value: 1},
        {text: 2, value: 2},
        {text: 3, value: 3},
        {text: 'OT', value: 4},
        {text: 'PSO', value: 5}
      ],
      situationOptions: [],
      shotResultOptions: [
          {text: 'On Net', value: 'on_net'},
          {text: 'Missed Net', value: 'missed_net'},
          {text: 'Blocked', value: 'blocked'},
          {text: 'Goal', value: 'goal'}
      ],
      faceoffResultOptions: [
          {text: 'Win Win', value: 'WinWin'},
          {text: 'Win Loss', value: 'WinLoss'},
          {text: 'Loss Loss', value: 'LossLoss'},
          {text: 'Loss Win', value: 'Loss Win'}
      ],
      turnoverResultOptions: [
          {text: 'Offensive', value: 'Offensive'},
          {text: 'Neutral', value: 'Neutral'},
          {text: 'Defensive', value: 'Defensive'},
          {text: 'NaN', value: ''}
      ],
      pimTypeOptions: [
          {text: 'Minor', value: 'minor'},
          {text: 'Major', value: 'major'},
          {text: 'Misconduct', value: 'misconduct'},
          {text: 'Match', value: 'match'},
          {text: 'Game', value: 'Game'},
          {text: 'NaN', value: ''}
      ],
      pimForOptions: [
          {text: 'Slashing', value: 'slashing'},
          {text: 'Cross Checking', value: 'cross_checking'},
          {text: 'Hit from Behind', value: 'hit_from_behind'},
          {text: 'Check To the Head', value: 'check_to_the_head'},
          {text: 'Hooking', value: 'hooking'},
          {text: 'Fighting', value: 'fighting'},
          {text: 'Roughing', value: 'roughing'},
          {text: 'Tripping', value: 'tripping'},
          {text: 'Boarding', value: 'boarding'},
          {text: 'Interference', value: 'interference'},
          {text: 'Abuse of Official', value: 'abuse_of_official'},
          {text: 'Too Many Men', value: 'too_many_men'},
          {text: 'Illegal Equipment', value: 'illegal_equipment'},
          {text: 'Unsportsmanlike Conduct', value: 'unsportsmanlike'},
          {text: 'High Stick', value: 'high_stick'},
          {text: 'Holding Stick', value: 'holding_stick'},
          {text: 'Third Man', value: 'third_man'},
          {text: 'Elbowing', value: 'elbowing'},
          {text: 'Kneeing', value: 'kneeing'},
          {text: 'Spearing', value: 'spearing'},
          {text: 'Hand Pass', value: 'hand_pass'},
          {text: 'Butt Ending', value: 'butt_ending'},
          {text: 'Charging', value: 'charging'},
          {text: 'NaN', value: ''}
      ]
    }
  },
  methods: {
    fetchFixtures () {
      this.$http.get('https://devilsapi.roblutken.com/api/game/get/' + this.$route.params.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        this.Fixture = response.data
        this.teamOptions.push({text: this.Fixture.home_team, value: this.Fixture.home_team})
        this.teamOptions.push({text: this.Fixture.away_team, value: this.Fixture.away_team})
      }, response => {
      })
    },
    fetchSituations () {
      this.$http.get('https://devilsapi.roblutken.com/api/get/situations', { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        this.Situations = response.data
        for (var i of this.Situations.situations) {
          this.situationOptions.push({text: i.secondary_situation, value: i.secondary_situation})
        }
      }, response => {
      })
    },
    fetchGoals () {
      if (this.$route.params.gameId > 0) {
        this.gameId = this.$route.params.gameId
        this.$http.get('https://devilsapi.roblutken.com/api/goals/get/game/' + this.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
        response => {
          this.Goals = response.data
        }, response => {
        })
      } else {
        this.$http.get('https://devilsapi.roblutken.com/api/goals/get', { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
        response => {
          this.Goals = response.data
        }, response => {
        })
      }
    },
    fetchShots () {
      if (this.$route.params.gameId > 0) {
        this.gameId = this.$route.params.gameId
        this.$http.get('https://devilsapi.roblutken.com/api/shots/get/game/' + this.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
        response => {
          this.Shots = response.data
        }, response => {
        })
      }
    },
    fetchFaceoffs () {
      if (this.$route.params.gameId > 0) {
        this.gameId = this.$route.params.gameId
        this.$http.get('https://devilsapi.roblutken.com/api/faceoffs/get/game/' + this.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
        response => {
          this.Faceoffs = response.data
        }, response => {
        })
      }
    },
    fetchTurnovers () {
      if (this.$route.params.gameId > 0) {
        this.gameId = this.$route.params.gameId
        this.$http.get('https://devilsapi.roblutken.com/api/turnovers/get/game/' + this.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
        response => {
          this.Turnovers = response.data
        }, response => {
        })
      }
    },
    fetchHits () {
      if (this.$route.params.gameId > 0) {
        this.gameId = this.$route.params.gameId
        this.$http.get('https://devilsapi.roblutken.com/api/hits/get/game/' + this.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
        response => {
          this.Hits = response.data
        }, response => {
        })
      }
    },
    fetchPims () {
      console.log('Get query pims' + this.$route.params.gameId)
      if (this.$route.params.gameId > 0) {
        this.gameId = this.$route.params.gameId
        this.$http.get('https://devilsapi.roblutken.com/api/pims/get/game/' + this.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
        response => {
          this.Pims = response.data
          console.log(response.data)
        }, response => {
        })
      }
    },
    fetchPlusMinus () {
      console.log('Get query plus minus' + this.$route.params.gameId)
      if (this.$route.params.gameId > 0) {
        this.gameId = this.$route.params.gameId
        this.$http.get('https://devilsapi.roblutken.com/api/plus-minus/get/game/' + this.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
        response => {
          this.PlusMinus = response.data
          console.log(response.data)
        }, response => {
        })
      }
    },
    fetchTimeOnIce (id) {
      this.$http.get('https://devilsapi.roblutken.com/api/players/home/get', { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        this.Player = response.data
        for (let i = 0; i < this.Player.length; i++) {
          this.TOI.push({
            player_id: this.Player[i].id,
            player_forename: this.Player[i].forename,
            player_surname: this.Player[i].surname,
            player_number: this.Player[i].player_number,
            played_in_game: 0,
            shots_for: 0,
            shots_against: 0,
            shifts: 0,
            avg_shift: '',
            total_time: '',
            time_5v5: '',
            time_4v4: '',
            time_PP: '',
            time_SH: ''
          })
        }
      }, response => {
      })
    },
    updateShotRow (shot) {
      // console.log('Shot Update + ' + JSON.stringify(shot))
      let updateShot = {
        team: shot.for_team.name,
        player_id: shot.home_player,
        game_time: shot.game_time,
        situation: shot.situation.secondary_situation,
        shot_type: shot.result,
        period: shot.period,
        shot_location: shot.location
      }
      console.log('Shot Update data: ' + JSON.stringify(updateShot))
      this.$http.put('https://devilsapi.roblutken.com/api/shots/update/' + shot.id,
      updateShot, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        console.log(response.data)
        if (response.data.status === '202') {
          openNotification({
            title: 'Update Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Failed to update',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
        // this.$router.push('/editors/goal/')
      }, response => {
      })
    },
    updateGoalRow (goal) {
      console.log('Goal: ' + goal)
      let updateGoal = {
        player_id: goal.scorer.player_number,
        first_assist: goal.first_assist.player_number,
        second_assist: goal.second_assist.player_number,
        period: goal.period,
        situation: goal.situation.secondary_situation
      }

      console.log(updateGoal)
      console.log(goal.id)
      this.$http.put('https://devilsapi.roblutken.com/api/goals/update/' + goal.id,
      updateGoal, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        console.log(response.data)
        if (response.data.status === '202') {
          openNotification({
            title: 'Update Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Failed to update',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
        // this.$router.push('/editors/goal/')
      }, response => {
      })
    },
    updateFaceoff (faceoff) {
      let updateFaceoff = {
        home_player: faceoff.home_player,
        away_player: faceoff.away_player,
        result: faceoff.result,
        lane: faceoff.lane,
        zone: faceoff.zone,
        period: faceoff.period,
        situation: faceoff.situation.secondary_situation,
        game_time: faceoff.game_time
      }
      console.log(JSON.stringify(updateFaceoff))
      this.$http.put('https://devilsapi.roblutken.com/api/faceoffs/update/' + faceoff.id,
      updateFaceoff, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        if (response.data.status === '202') {
          openNotification({
            title: 'Update Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Failed to update',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
      }, response => {
      })
    },
    updateTurnover (turnover) {
      let updateTurnover = {
        home_player: turnover.home_player,
        result: turnover.type,
        period: turnover.period,
        situation: turnover.situation.secondary_situation,
        game_time: turnover.game_time
      }
      console.log(JSON.stringify(updateTurnover))
      this.$http.put('https://devilsapi.roblutken.com/api/turnovers/update/' + turnover.id,
      updateTurnover, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        if (response.data.status === '202') {
          openNotification({
            title: 'Update Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Failed to update',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
      }, response => {
      })
    },
    updateHit (hit) {
      let updateHit = {
        home_player: hit.home_player,
        away_player: hit.away_player,
        period: hit.period,
        situation: hit.situation.secondary_situation,
        game_time: hit.game_time
      }
      console.log(JSON.stringify(updateHit))
      this.$http.put('https://devilsapi.roblutken.com/api/hits/update/' + hit.id,
      updateHit, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        if (response.data.status === '202') {
          openNotification({
            title: 'Update Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Failed to update',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
      }, response => {
      })
    },
    updatePIM (pim) {
      let updatePim = {
        taker: pim.taker,
        drawer: pim.drawer,
        type: pim.type,
        for: pim.for,
        time: pim.time,
        period: pim.period,
        game_time: pim.game_time
      }
      console.log(JSON.stringify(updatePim))
      this.$http.put('https://devilsapi.roblutken.com/api/pims/update/' + pim.id,
      updatePim, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        if (response.data.status === '202') {
          openNotification({
            title: 'Update Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Failed to update',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
      }, response => {
      })
    },
    deleteGoal (goal) {
      this.$http.get('https://devilsapi.roblutken.com/api/goals/delete/' + goal.id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        console.log(response.data)
        if (response.data.status === '202') {
          openNotification({
            title: 'Delete Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Failed to delete',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
      })
    },
    deleteShot (shot) {
      this.$http.get('https://devilsapi.roblutken.com/api/shots/delete/' + shot.id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        console.log(response.data)
        if (response.data.status === '202') {
          openNotification({
            title: 'Delete Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Failed to delete',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
      })
    },
    deleteFacoff (faceoff) {
      this.$http.get('https://devilsapi.roblutken.com/api/faceoffs/delete/' + faceoff.id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        console.log(response.data)
        if (response.data.status === '202') {
          openNotification({
            title: 'Delete Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Failed to delete',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
      })
    },
    deleteHit (hit) {
      this.$http.get('https://devilsapi.roblutken.com/api/hits/delete/' + hit.id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        console.log(response.data)
        if (response.data.status === '202') {
          openNotification({
            title: 'Delete Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Failed to delete',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
      })
    },
    deleteTurnover (turnover) {
      this.$http.get('https://devilsapi.roblutken.com/api/turnover/delete/' + turnover.id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        console.log(response.data)
        if (response.data.status === '202') {
          openNotification({
            title: 'Delete Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Failed to delete',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
      })
    },
    deletePIM (PIM) {
      this.$http.get('https://devilsapi.roblutken.com/api/pims/delete/' + PIM.id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        console.log(response.data)
        if (response.data.status === '202') {
          openNotification({
            title: 'Delete Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Failed to delete',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
      })
    },
    addPIM (PIM) {
      console.log('New pim' + JSON.stringify(PIM))
    },
    openNotificationWithType (type) {
      openNotification({
        title: 'This is a title',
        message: 'This is the message.',
        type: type
      })
    }
  },
  created: function () {
    this.fetchGoals()
    this.fetchFixtures()
    this.fetchShots()
    this.fetchSituations()
    this.fetchFaceoffs()
    this.fetchTurnovers()
    this.fetchHits()
    this.fetchPims()
    this.fetchTimeOnIce()
  },
  update: function () {
    this.fetchGoals()
  }
}
</script>



// WEBPACK FOOTER //
// game-editor.vue?1621e182